(() => {
  window.Tilemall = window.Tilemall || {};

  if (window.Tilemall.hubspotForms) {
    window.Tilemall.hubspotForms.init(document);
    return;
  }

  const formSelector = '[data-hubspot-form]';
  const scriptSelector = 'script[data-tm-hubspot-forms]';
  const scriptUrl = 'https://js.hsforms.net/forms/embed/v2.js';
  let scriptPromise;

  const loadScript = () => {
    if (window.hbspt?.forms?.create) return Promise.resolve(window.hbspt);
    if (scriptPromise) return scriptPromise;

    scriptPromise = new Promise((resolve, reject) => {
      let script = document.querySelector(scriptSelector);
      const timeoutId = window.setTimeout(() => {
        reject(new Error('HubSpot Forms script timed out'));
      }, 15000);

      const handleLoad = () => {
        window.clearTimeout(timeoutId);
        if (window.hbspt?.forms?.create) {
          resolve(window.hbspt);
        } else {
          reject(new Error('HubSpot Forms script loaded without the Forms API'));
        }
      };

      const handleError = () => {
        window.clearTimeout(timeoutId);
        reject(new Error('HubSpot Forms script failed to load'));
      };

      if (!script) {
        script = document.createElement('script');
        script.src = scriptUrl;
        script.async = true;
        script.dataset.tmHubspotForms = '';
        script.addEventListener('load', handleLoad, { once: true });
        script.addEventListener('error', handleError, { once: true });
        document.head.appendChild(script);
      } else {
        script.addEventListener('load', handleLoad, { once: true });
        script.addEventListener('error', handleError, { once: true });
      }
    }).catch((error) => {
      scriptPromise = undefined;
      throw error;
    });

    return scriptPromise;
  };

  const getForms = (root) => {
    const forms = [];
    if (root.matches?.(formSelector)) forms.push(root);
    forms.push(...root.querySelectorAll(formSelector));
    return forms;
  };

  const init = (root = document) => {
    const forms = getForms(root).filter((form) => !form.dataset.hubspotFormState);
    if (!forms.length) return;

    forms.forEach((form) => {
      form.dataset.hubspotFormState = 'loading';
    });

    loadScript()
      .then(() => {
        forms.forEach((form) => {
          if (!form.isConnected) return;

          const { region, portalId, formId } = form.dataset;
          if (!region || !portalId || !formId || !form.id) {
            form.dataset.hubspotFormState = 'error';
            console.error('HubSpot form configuration is incomplete.', form);
            return;
          }

          try {
            form.dataset.hubspotFormState = 'created';
            window.hbspt.forms.create({
              region,
              portalId,
              formId,
              target: `#${form.id}`,
              onFormReady: () => {
                if (form.isConnected) form.dataset.hubspotFormState = 'ready';
              }
            });
          } catch (error) {
            form.dataset.hubspotFormState = 'error';
            console.error('HubSpot form failed to initialize.', error);
          }
        });
      })
      .catch((error) => {
        forms.forEach((form) => {
          if (form.isConnected) form.dataset.hubspotFormState = 'error';
        });
        console.error('HubSpot Forms failed to load.', error);
      });
  };

  window.Tilemall.hubspotForms = { init };
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
